/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from '@store/getters.constants';

const getters = {
  [storeGetters.getDomain]: (state) => {
    return state.domain;
  },
  [storeGetters.getDomains]: (state) => {
    return state.domains;
  },
//   [storeGetters.getLicenseByid]: (state) => {
//     return state.license;
//   },
//   [storeGetters.getLicenseCount]: (state) => {
//     return state.licenseCount;
//   },
};
export default { ...getters };